var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5989 22.2498H9.74049C4.57568 22.2498 2.3667 20.1498 2.3667 15.2398V15.1098C2.3667 10.6698 4.20752 8.52978 8.33095 8.15978C8.75171 8.12978 9.15143 8.42978 9.19351 8.83978C9.23558 9.24978 8.92001 9.61978 8.47822 9.65978C5.17526 9.94978 3.94454 11.4298 3.94454 15.1198V15.2498C3.94454 19.3198 5.45927 20.7598 9.74049 20.7598H16.5989C20.8801 20.7598 22.3948 19.3198 22.3948 15.2498V15.1198C22.3948 11.4098 21.143 9.92978 17.777 9.65978C17.3457 9.61978 17.0196 9.25978 17.0617 8.84978C17.1038 8.43978 17.4719 8.12978 17.9137 8.16978C22.1003 8.50978 23.9726 10.6598 23.9726 15.1298V15.2598C23.9726 20.1498 21.7637 22.2498 16.5989 22.2498Z",
    fill: "#1D244A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1695 15.63C12.7383 15.63 12.3806 15.29 12.3806 14.88V2C12.3806 1.59 12.7383 1.25 13.1695 1.25C13.6008 1.25 13.9585 1.59 13.9585 2V14.88C13.9585 15.3 13.6008 15.63 13.1695 15.63Z",
    fill: "#1D244A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1695 16.7498C12.9697 16.7498 12.7698 16.6798 12.612 16.5298L9.08816 13.1798C8.78311 12.8898 8.78311 12.4098 9.08816 12.1198C9.39321 11.8298 9.89812 11.8298 10.2032 12.1198L13.1695 14.9398L16.1359 12.1198C16.4409 11.8298 16.9458 11.8298 17.2509 12.1198C17.5559 12.4098 17.5559 12.8898 17.2509 13.1798L13.727 16.5298C13.5692 16.6798 13.3694 16.7498 13.1695 16.7498Z",
    fill: "#1D244A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4103c184dd11cc5c70f1b51f5fbd375a.svg";
export { ForwardRef as ReactComponent };